import { render, staticRenderFns } from "./SettingOptionDialog.vue?vue&type=template&id=3a1bf855&scoped=true"
import script from "./SettingOptionDialog.vue?vue&type=script&lang=js"
export * from "./SettingOptionDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingOptionDialog.vue?vue&type=style&index=0&id=3a1bf855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bf855",
  null
  
)

export default component.exports